export class BudgetingPlannerWithCategoryAndSeason {
    constructor() {
        this.budgetingPlanner = null;
        this.category = null;
        this.season = null;
    }
}